var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


Curriculog.ProposalForm.RichTextModel = (function ($, _, Backbone, RichTextModel) {

    RichTextModel = Curriculog.ProposalForm.FieldModel.extend({

        initialize: function(attrs, options) {
            Curriculog.ProposalForm.FieldModel.prototype.initialize.apply(this, arguments);

            this.bindValidation(attrs);
        },

        /**
         * Overrides the existing field validation to work with our JSONified field values
         *
         * @param   {Object} attrs - This models attributes
         */
        bindValidation: function(attrs) {
            var maxLength = attrs.maxLength,
                field = attrs.displayText,
                required = attrs.required;

            /**
             * Custom smartfield validator
             *
             * @param   {String} value         - The fields value.
             * @param   {String} attr          - The name of the attribute - always 'value'.
             * @param   {Object} computedState - The models attributes before change.
             * @returns {String|undefined}     - String message on error | undefined on success.
             */
            this.validation.value = function(value, attr, computedState) {
                var text_value = $('<div>' + value + '</div>').text().trim();

                if (required && !text_value.length) {
                    return field +' is required.';
                }

                if (maxLength < 1 || value.length <= maxLength) {
                    return undefined;
                }

                return field +' must be at most '+ maxLength +' characters.';
            };
        }
    });

    return RichTextModel;

})($, _, Backbone, Curriculog.ProposalForm.RichTextModel || {});
